import { TextField } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { FormFieldContract } from "@totalenergiescode/mobility-business-rev-form-data/lib";

interface EditableTextFieldProps {
  field: FormFieldContract;
}

function EditableTextField({ field }: Readonly<EditableTextFieldProps>) {
  const { dataTestIdPrefix, translatorFor } = useFormDataContext();

  if (!field) return null;

  const value = field.value.asString();
  const currentValue = value.value() || value.defaultValue();

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);
  const help = translateField(translator, field, Suffix.HELP);

  const errorMessage =
    field.violations().length > 0
      ? field.violations().at(0)?.translate(translator)
      : undefined;

  const required = field.required;
  const writable = field.writable;

  function handleFieldChange(event: React.ChangeEvent<HTMLInputElement>) {
    field.setValue(event.target.value);
  }

  return (
    <TextField
      type='text'
      label={label.toString()}
      helperText={field.hasHelper() ? help.toString() : undefined}
      value={currentValue}
      onChange={handleFieldChange}
      disabled={!writable}
      isError={Boolean(errorMessage)}
      errorText={errorMessage || ""}
      required={required}
      dataTestId={`${dataTestIdPrefix}-${field.id()}`}
    />
  );
}

export default EditableTextField;
